const SummaryTableSchema = [
    {
        objectName: 'PurchaseOrderCommitLineSummary',
        isLoading: 'loadingPurchaseOrderCommitLineSummary',
        paperElevation: 0,
        children: [
            {
                label: 'Product',
                fieldNames: [
                    'ProductIdDisplay',
                    'ProductIdDisplayLabel'
                ],
                valueRenderer: {
                    hyperLink: {
                        link: false,
                        menu: true
                    },
                    api: {
                        api: '/inventoryEnquiry/lookup/action',
                        name: 'enquiry',
                        params: {
                            queryFields: {
                                ProductId: 'ProductId'
                            }
                        }
                    }
                }
            },
            {
                label: 'Product Group',
                fieldNames: [
                    'ProductGroup',
                    'ProductGroupLabel',
                ]
            },
        ]
    },
    {
        objectName: 'PurchaseOrderCommitLineSummary',
        isLoading: 'loadingPurchaseOrderCommitLineSummary',
        paperElevation: 0,
        children: [
            {
                label: 'On Order',
                fieldNames: [
                    'OnOrderQuantityDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Committed',
                fieldNames: [
                    'CommittedQuantityDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            }
        ]
    },
    {
        objectName: 'PurchaseOrderCommitLineSummary',
        isLoading: 'loadingPurchaseOrderCommitLineSummary',
        paperElevation: 0,
        children: [
            {
                label: 'Due Date',
                fieldNames: [
                    'DueDate'
                ],
            },
        ]
    },
];

export default SummaryTableSchema;
